require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-introducing-rob-wills.json") })
        }
      }, "path---news-introducing-rob-wills");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-introducing-rob-wills!./.cache/json/news-introducing-rob-wills.json
// module id = 1424
// module chunks = 231608221292675